export const brazilFlags = [45, 185, 186, 187];